import React, { ReactNode, ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

interface IconBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  onClick: () => void;
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'inherit';
  edge?: 'start' | 'end';
  variant?: 'contained' | 'outlined';
  size?: "small" | "medium" | "large"
}

export function IconBtn({ 
  children,
  onClick,
  type="button",
  color="inherit",
  disabled = false,
  size="medium",
  edge,
  variant,
  ...props
}: IconBtnProps) {
  const icon = React.Children.only(children);

  const btnClasses = clsx(
    'flex items-center justify-center rounded-full hover:bg-gray-50 dark:hover:bg-neutral-600',
    size === "small" && "p-0.5",
    size === "medium" && "p-1",
    size === "large" && "p-2",
    color === 'primary' && 'text-primary',
    color === 'secondary' && 'text-secondary',
    color === 'error' && 'text-error-500',
    color === 'warning' && 'text-warning-500',
    // outlined
    variant === 'outlined' && "border",
    color === "primary" && variant === 'outlined' && "border-primary",
    color === "secondary" && variant === 'outlined' && "border-secondary",
    color === 'inherit' && variant === 'outlined' && 'text-typography-primary border-gray-900 dark:border-white dark:hover:border-gray-50',
    edge === 'start' && '-ml-2',
    edge === 'end' && '-mr-2',
    disabled && ['opacity-50', 'cursor-not-allowed'],
  );

  return (
    <button
      className={btnClasses}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...props}
    >
      {icon}
    </button>
  );
}

export default IconBtn;
